import { Component } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { MollieCardsPaymentComponentDef } from '@df/module-mollie/cards/mollie-cards-payment.component.def';
import { ResultComponent } from '../../../ui/resut/result.component';
@Component({
    selector: 'mollie-cards-payment',
    templateUrl: './mollie-cards-payment.html',
    standalone: true,
    imports: [ResultComponent],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class MollieCardsPaymentComponent extends MollieCardsPaymentComponentDef {}
